import { createAction, props } from '@ngrx/store';

export const setCoinAction = createAction(
  '[COIN] Set COIN',
  props<{ coin: string }>()
);